import { Construction, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { sendCustomEvent } from '@Analytics';
import { FullPageStatus } from '@Components/FullPageStatus';

interface WorkInProgressProps {
  /** Optional override for the main heading (i18n key). */
  titleKey?: string;
  /** Optional override for the description (i18n key). */
  descriptionKey?: string;
}

/**
 * "Coming soon" placeholder for features that exist in the navigation but
 * don't have a real implementation yet (e.g. Maestros in the Logyca flavor).
 */
const WorkInProgress = ({ titleKey, descriptionKey }: WorkInProgressProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goHome = () => {
    sendCustomEvent('BUTTON_CLICKED', { buttonName: 'WIP_GO_HOME' });
    navigate('/');
  };

  return (
    <FullPageStatus
      watermark="SOON"
      tone="warning"
      icon={Construction}
      title={t(titleKey || 'Global.WorkInProgressTitle')}
      description={t(descriptionKey || 'Global.WorkInProgressMessage')}
      actions={[{ label: t('Global.GoHome'), icon: Home, variant: 'primary', onClick: goHome }]}
    />
  );
};

export default WorkInProgress;
